import { Injectable } from "@angular/core";
import { MapDefinition } from "../model/map.model";
import { MapDefinitionDto } from "../model/map.dto";

@Injectable({ providedIn: "root" })
export class MapMapper {
    public dtoToMapDefinitioner(dto: MapDefinitionDto): MapDefinition {
        const [startKoordinaterX, startKoordinaterY] = dto.startKoordinater.split(",").map((coord) => parseFloat(coord.trim()));

        return {
            startKoordinaterX,
            startKoordinaterY,
            tileLayer: dto.tileLayer,
            layers: dto.layers,
            hoejde: parseInt(dto.hoejde, 10),
            mapZoom: parseInt(dto.mapZoom, 10),
            scrollWheelZoom: dto.scrollWheelZoom === "True"
        };
    }
}
